/* global gtag */

import Vue from 'vue'
import Router from 'vue-router'
import VueCookies from 'vue-cookies'
import Hello from '@/components/Hello'
import Homepage from '@/components/Homepage'
import About from '@/components/About'
import Service from '@/components/Service'
import Projects from '@/components/Projects'
import Products from '@/components/Products'
import ContactUs from '@/components/ContactUs'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import DProducts from '@/components/DProducts'
import DProjects from '@/components/DProjects'
import DClients from '@/components/DClients'
import Settings from '@/components/Settings'
import AddProduct from '@/components/AddProduct'
import EditProduct from '@/components/EditProduct'
import AddProject from '@/components/AddProject'
import AddClient from '@/components/AddClient'
import EditProject from '@/components/EditProject'
import Inquiries from '@/components/Inquiries'
import IncomingContactForms from '@/components/IncomingContactForms'
import EmailSubscribers from '@/components/EmailSubscribers'
import ComposeEmail from '@/components/ComposeEmail'

Vue.use(Router)
Vue.use(VueCookies)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'Homepage',
      component: Homepage
    },
    {
      path: '*',
      name: 'All',
      component: Homepage
    },
    {
      path: '/hello',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/service',
      name: 'Service',
      component: Service
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects
    },
    {
      path: '/products',
      name: 'Products',
      component: Products
    },
    {
      path: '/contact',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        auth: true
      }
    },
    {
      path: '/dproducts',
      name: 'DProducts',
      component: DProducts,
      meta: {
        auth: true
      }
    },
    {
      path: '/dclients',
      name: 'DClients',
      component: DClients,
      meta: {
        auth: true
      }
    },
    {
      path: '/dprojects',
      name: 'DProjects',
      component: DProjects,
      meta: {
        auth: true
      }
    },
    {
      path: '/editproject/:id',
      name: 'EditProject',
      component: EditProject,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: {
        auth: true
      }
    },
    {
      path: '/addproduct',
      name: 'AddProduct',
      component: AddProduct,
      meta: {
        auth: true
      }
    },
    {
      path: '/editproduct/:id',
      name: 'EditProduct',
      component: EditProduct,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: '/addProject',
      name: 'AddProject',
      component: AddProject,
      meta: {
        auth: true
      }
    },
    {
      path: '/addClient',
      name: 'AddClient',
      component: AddClient,
      meta: {
        auth: true
      }
    },
    {
      path: '/inquiries',
      name: 'Inquiries',
      component: Inquiries,
      meta: {
        auth: true
      }
    },
    {
      path: '/contactforms',
      name: 'IncomingContactForms',
      component: IncomingContactForms,
      meta: {
        auth: true
      }
    },
    {
      path: '/subscribers',
      name: 'EmailSubscribers',
      component: EmailSubscribers,
      meta: {
        auth: true
      }
    },
    {
      path: '/composeemail',
      name: 'ComposeEmail',
      component: ComposeEmail,
      meta: {
        auth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.auth) {
    if (Vue.cookies.get('uses') === null || Vue.cookies.get('uses') === undefined) {
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  if (to.path === '/contact') {
    if (typeof gtag !== 'undefined') {
      console.log('[Google Ads] Firing conversion event')
      gtag('event', 'conversion', {
        'send_to': 'AW-17042046818/K0JsCPLXoL8aEOL-o74_',
        'value': 1.0,
        'currency': 'IDR'
      })
    } else {
      console.warn('gtag not defined yet')
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js